import { render, staticRenderFns } from "./order.vue?vue&type=template&id=194992a3&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=194992a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194992a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194992a3')) {
      api.createRecord('194992a3', component.options)
    } else {
      api.reload('194992a3', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=194992a3&scoped=true&", function () {
      api.rerender('194992a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/order.vue"
export default component.exports